<template>
  <div class="auth-page" id="formConfirmOtp">
    <div class="auth-page__inner">
      <div class="auth-page__brand">
        <div class="auth-page__brand-bg"></div>
        <div class="auth-page__brand-pattern"></div>
        <div class="auth-page__brand-content">
          <h1 class="auth-page__brand-title">Xác thực mã OTP</h1>
          <p class="auth-page__brand-desc">Mã OTP đã được gửi tới email của bạn. Nhập mã 6 chữ số để hoàn tất đăng nhập.</p>
          <ul class="auth-page__brand-features">
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-envelope"></i></span>
              <span><strong>Mã 6 chữ số</strong> Kiểm tra email (và thư mục thư rác/spam) để lấy mã OTP do hệ thống gửi.</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-clock-o"></i></span>
              <span><strong>Mã có thời hạn</strong> Mã OTP chỉ có hiệu lực trong thời gian hiển thị bên cạnh. Hết hạn có thể bấm "Gửi lại mã".</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-refresh"></i></span>
              <span><strong>Gửi lại / Thử gửi lại</strong> Nếu không nhận được email, dùng "Gửi lại mã" hoặc "Tôi không nhận được OTP" sau khi hết thời gian chờ.</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="auth-page__form-side">
        <div class="auth-page__form-side-pattern" aria-hidden="true"></div>
        <div class="auth-page__wrap">
          <CCard no-body class="auth-page__card">
            <CCardBody class="auth-page__card-body">
              <CForm id="form-confirm-otp" class="auth-page__form" v-on:submit.prevent>
                <h2 class="auth-page__title form-fade-in-top">Xác thực mã OTP</h2>
                <p class="auth-page__subtitle">Nhập mã 6 chữ số từ email của bạn</p>
                <div class="form-fade-in-bottom">
                  <div class="auth-page__otp-hint">
                    Nếu không nhận được email, kiểm tra hòm thư → thư rác (spam).
                  </div>
                  <div class="mb-2">
                    <BaseInput :options="otpInput.options" :data="otpInput.data" class="input-wrapper" />
                  </div>
                  <div class="auth-page__countdown-wrap">
                    <div class="countdown">
                      <div class="block">
                        <p class="digit"><i class="fa fa-clock-o" aria-hidden="true"></i> {{ minutes | two_digits }}</p>
                      </div>
                      <div class="block">
                        <p class="digit">:{{ seconds | two_digits }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="auth-page__btn-group auth-page__btn-group--row">
                    <button
                      type="button"
                      class="auth-btn-secondary"
                      @click.prevent="submitResendOTP()"
                    >
                      Gửi lại mã
                    </button>
                    <button
                      type="button"
                      class="auth-btn-primary ripple btn-primary"
                      :disabled="disableBtnVerifyOTP"
                      @click.prevent="submitVerifyOTP()"
                    >
                      Xác thực
                      <div class="ripple-effect" hidden></div>
                    </button>
                  </div>
                  <button
                    type="button"
                    class="auth-link auth-link--block"
                    :disabled="retryOTP.isDisabled"
                    @click.prevent="submitRetrySendOTP()"
                  >
                    Tôi không nhận được OTP <span v-if="retryOTP.isDisabled">({{ formattedTime }})</span>
                  </button>
                  <div class="auth-footer">Hỗ trợ: {{ HOTLINE }}</div>
                </div>
              </CForm>
            </CCardBody>
          </CCard>
        </div>
      </div>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>
<script>
import Vue from "vue";
import BaseLoading from "../base/BaseFormLoading";
import BaseInput from "../base/BaseInput";

import {authLogin, authLogout} from "@/security/index";
import {ACCESS_TOKEN_NAME, TIME_OTP_EXPIRED, USER_NAME, USER_ID, CLIENT_ID_NAME, HOTLINE} from "@/constant";

/** Chỉ coi verify OTP thành công khi server thật sự trả bộ token đăng nhập (tránh chỉnh JSON response giả). */
function isOtpVerifyLoginPayload(data) {
  if (!data || typeof data !== 'object') {
    return false;
  }
  const at = data.access_token;
  const auth = data.authorities;
  return typeof at === 'string' && at.length > 10
    && Array.isArray(auth) && auth.length > 0;
}

Vue.filter('two_digits', (value) => {
  if (value < 0) {
    return '00';
  }
  if (value.toString().length <= 1) {
    return `0${value}`;
  }
  return value;
});

export default {
  name: "ConfirmOTP",
  components: {BaseInput, BaseLoading},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  mounted: function () {
    let that = this;
    setTimeout(function () {
      that.setUpRippleButton();
    }, 500);
    this.now = Math.trunc((new Date()).getTime() / 1000);
    this.interValCountdown();
    setTimeout(function () {
      that.$helper.setupInputNumber('confirm-otp');
      that.$el.querySelector(".confirm-otp").focus();
    }, 200);
    this.checkTimeExpOTP();
    this.startCountdownRetryOTP();
    // this.checkIntervalRedirectLogin();
  },
  created: function () {
    this.checkTimeRedirectLogin();
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      now: '',
      otpInterVal: '',
      retryOtpInterval: '',
      disableBtnVerifyOTP: false,
      timeExpOTP: localStorage.getItem(TIME_OTP_EXPIRED) || '',
      intervalRedirectLogin: '',
      HOTLINE: HOTLINE,

      retryOTP: {
        isDisabled: true,
        minutes: 1,
        seconds: 0
      },

      otpInput: {
        options: {
          type: 'text',
          placeholder: "Mã OTP",
          maxlength: 6,
          addInputClasses: "confirm-otp",
        },
        data: {
          name: "otp",
          model: "",
          updateCallback: function () {
            that.submitVerifyOTP();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.otpInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mã xác thực OTP không được để trống";
                that.$el.querySelector(".confirm-otp").focus();
              } else if (value.length < 6) {
                this.isValid = false;
                this.errorMessage = "Mã xác thực OTP gồm 6 chữ số";
                that.$el.querySelector(".confirm-otp").focus();
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
    };
  },
  computed: {
    dateInMilliseconds() {
      let time = new Date(this.timeExpOTP * 1);
      return Math.trunc(Date.parse(this.$helper.formatDateYYYYMMDDHHMMSS(time)) / 1000)
    },
    seconds() {
      return (this.dateInMilliseconds - this.now) % 60;
    },
    minutes() {
      return Math.trunc((this.dateInMilliseconds - this.now) / 60);
    },

    formattedTime() {
      // Đảm bảo luôn có 2 chữ số bằng cách sử dụng padStart
      const formattedMinutes = String(this.retryOTP.minutes).padStart(2, '0');
      const formattedSeconds = String(this.retryOTP.seconds).padStart(2, '0');
      return `${formattedMinutes}:${formattedSeconds}`;
    }
  },
  watch: {
    'now': function (value) {
      let timeExp = localStorage.getItem(TIME_OTP_EXPIRED);
      let dateExp = new Date(timeExp * 1);
      if (dateExp <= new Date(value)) {
        this.disableBtnVerifyOTP = true;
        clearInterval(this.otpInterVal);
      }
    },
  },
  methods: {
    checkTimeRedirectLogin() {
      let timeExp = localStorage.getItem(TIME_OTP_EXPIRED);
      if (localStorage.getItem(ACCESS_TOKEN_NAME)) {
        this.$router.push({path: '/dashboard.html'});
      } else {
        if (timeExp) {
          let timeRedirect = this.$helper.plusDatetime(new Date(timeExp * 1), 2, 'm');
          if (timeRedirect <= new Date()) {
            authLogout();
          }
        } else {
          authLogout();
        }
      }
    },
    interValCountdown() {
      this.otpInterVal = window.setInterval(() => {
        this.now = Math.trunc((new Date()).getTime() / 1000);
      }, 1000);
    },
    checkTimeExpOTP() {
      let timeExp = localStorage.getItem(TIME_OTP_EXPIRED);
      if (timeExp && timeExp != undefined) {
        let dateExp = new Date(timeExp * 1);
        if (dateExp <= new Date()) {
          this.disableBtnVerifyOTP = true;
        }
      }
    },
    setUpRippleButton: function () {
      $(".ripple").on("click", function (event) {
        event.preventDefault();
        let $div = $("<div/>"),
          btnOffset = $(this).offset(),
          xPos = event.pageX - btnOffset.left,
          yPos = event.pageY - btnOffset.top;
        $div.addClass("ripple-effect");
        let $ripple = $(".ripple-effect");
        $div
          .css({
            top: yPos - $ripple.height() / 2,
            left: xPos - $ripple.width() / 2
          })
          .appendTo($(this));
        window.setTimeout(function () {
          $div.remove();
        }, 1500);
      });
    },
    submitVerifyOTP: function () {
      let that = this;
      if (!this.otpInput.data.validator.valid()) {
        return;
      }
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/verify-otp",
        isJsonContentType: false,
        isRequestBearerToken: false,
        dataSubmit: function () {
          return {
            username: btoa(localStorage.getItem(USER_NAME)),
            otp: btoa(that.otpInput.data.model),
            client_id: btoa(localStorage.getItem(CLIENT_ID_NAME))
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
            that.$el.querySelector(".confirm-otp").focus();
            return;
          }
          const {data} = response.data;
          if (!isOtpVerifyLoginPayload(data)) {
            that.showErrorMsg({
              message: 'Xác thực thất bại. Vui lòng thử lại!'
            });
            that.$el.querySelector(".confirm-otp").focus();
            return;
          }
          localStorage.removeItem(TIME_OTP_EXPIRED);
          const loginUser = data.user_name || data.username || localStorage.getItem(USER_NAME);
          const loginId = data.id != null && data.id !== '' ? data.id : (localStorage.getItem(USER_ID) || '');
          const systems = data.systems != null ? JSON.stringify(data.systems) : '[]';
          authLogin(
            data.access_token,
            null,
            data.expires_in,
            data.authorities,
            loginUser,
            data.fullName,
            loginId,
            systems,
            data.lastUpdatePassword
          );
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitResendOTP: function () {
      let that = this;
      this.otpInput.data.model = '';
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/resend-otp",
        isJsonContentType: false,
        isRequestBearerToken: false,
        dataSubmit: function () {
          return {
            username: btoa(localStorage.getItem(USER_NAME)),
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            that.now = Math.trunc((new Date()).getTime() / 1000);
            that.timeExpOTP = response.data.data;
            that.resetCountDownRetryOtp();
            that.interValCountdown();
            localStorage.setItem(TIME_OTP_EXPIRED, response.data.data);
            that.disableBtnVerifyOTP = false;
            that.showSuccessMsg({message: "Mã xác thực OTP đã được gửi lại vào email. Vui lòng kiểm tra lại."})
            that.$el.querySelector(".confirm-otp").focus();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    submitRetrySendOTP: function () {
      let that = this;
      that.resetCountDownRetryOtp();
      this.otpInput.data.model = '';
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/retry-otp",
        isJsonContentType: false,
        isRequestBearerToken: false,
        dataSubmit: function () {
          return {
            username: btoa(localStorage.getItem(USER_NAME)),
          };
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            that.now = Math.trunc((new Date()).getTime() / 1000);
            that.timeExpOTP = response.data.data;
            that.interValCountdown();
            localStorage.setItem(TIME_OTP_EXPIRED, response.data.data);
            that.disableBtnVerifyOTP = false;
            that.showSuccessMsg({message: "Mã xác thực OTP đã được gửi lại vào email. Vui lòng kiểm tra lại."})
            that.$el.querySelector(".confirm-otp").focus();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    resetCountDownRetryOtp() {
      clearInterval(this.retryOtpInterval);
      this.retryOTP.minutes = 2;
      this.retryOTP.seconds = 0;
      this.retryOTP.isDisabled = true;
      this.startCountdownRetryOTP();
    },
    startCountdownRetryOTP() {
      this.retryOtpInterval = setInterval(() => {
        if (this.retryOTP.seconds === 0) {
          if (this.retryOTP.minutes === 0) {
            clearInterval(this.retryOtpInterval);
            this.retryOTP.isDisabled = false;
          } else {
            this.retryOTP.minutes--;
            this.retryOTP.seconds = 59;
          }
        } else {
          this.retryOTP.seconds--;
        }
      }, 1000);
    }
  },
  destroyed() {
    clearInterval(this.intervalRedirectLogin);
  }
};
</script>

<style scoped>
</style>
